import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { TechnicalReportDto } from "@/core/features/technical-reports/technical-report.dto";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { CreateFileDto } from "@/core/features/file/create-file.dto";
import { plainToInstance } from "class-transformer";

export class TechnicalReportsResource extends ResourceBaseService<TechnicalReportDto, null, null> {
  protected EntityDto = TechnicalReportDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/technical-reports");
  }

  setActive(id: string): Promise<TechnicalReportDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/active",
        method: "PATCH",
        auth: true,
        body: {},
      })
    );
  }

  setCompleted(id: string): Promise<TechnicalReportDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/completed",
        method: "PATCH",
        auth: true,
        body: {},
      })
    );
  }

  createFinalReport(id: string, body: CreateFileDto): Promise<TechnicalReportDto> {
    return this.apiHttpClient.request<CreateFileDto, TechnicalReportDto>(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/final-report",
        method: "POST",
        auth: true,
        body: plainToInstance(CreateFileDto, body, { excludeExtraneousValues: true }),
      })
    );
  }

  removeFinalReport(id: string) {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/final-report",
        method: "PATCH",
        auth: true,
        body: {},
      })
    );
  }

  async downloadReport(id: string): Promise<{ jobId: string }> {
    const jobResponse = await this.apiHttpClient.request<null, { jobId: string }>(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/download-report",
        method: "POST",
        auth: true,
      })
    );

    if (!jobResponse?.jobId) {
      throw new Error("No se pudo encolar el trabajo");
    }

    return jobResponse;
  }

  async exists(filters: { worksheetId?: string; projectId?: string; reportTemplateId?: string }): Promise<boolean> {
    const query = new URLSearchParams();

    if (filters.worksheetId) {
      query.set("worksheetId", filters.worksheetId);
    }

    if (filters.projectId) {
      query.set("projectId", filters.projectId);
    }

    if (filters.reportTemplateId) {
      query.set("reportTemplateId", filters.reportTemplateId);
    }

    const response = await this.apiHttpClient.request<null, { exists: boolean }>(
      HttpRequest.create({
        url: this.resourceUrl + "/exists",
        method: "GET",
        auth: true,
        query: query.toString(),
      })
    );

    return response.exists;
  }
}
